import dict from './dict'
import Vue from 'vue'
import iView from 'iview'
import { _api, _http, util } from '@/libs'
import { PhotoPreview, ImageView } from '@/components/libs'
Vue.component('PhotoPreviewDirective', PhotoPreview)
Vue.component('ImageView', ImageView)


const directive = {
  preview(el, binding) {
    el.onclick = () => {
      if (binding.value) {
        iView.Spin.show({
          render: (h) => {
            return h('PhotoPreviewDirective', {
              props: { item: binding.value.item, list: binding.value.list }
            })
          }
        })
      }
    }
  },
  dict(el, binding) {
    if (binding.value && binding.arg) {
      const keys = Object.keys(binding.modifiers)
      let key = keys.length ? binding.arg + '.' + keys.join('.') : binding.arg
      dict.dict(key).then(res => {
        el.innerHTML = res.content[binding.value] || '--'
      })
    } else {
      el.innerHTML = '--'
    }
  },
  dist6nameZh(el, binding) {
    if (binding.value) {
      if (binding.value == '00' || binding.value == '00') {
        el.innerHTML = '全国'
      } else {
        dict.dist6nameZh(binding.value).then(res => {
          el.innerHTML = res
        })
      }
    } else {
      el.innerHTML = '--'
    }
  },
  branchNameById(el, binding) {
    _http.get(_api.sys.sysAdmin.branch, { params:{id: binding.value} }).then(payload => {
      el.innerHTML = payload.name
    })
  },
}

export default {
  dict: {
    bind: directive.dict,
    update: directive.dict
  },
  dist6nameZh: {
    update: directive.dist6nameZh,
    bind: directive.dist6nameZh
  },
  branchNameById: {
    update: directive.branchNameById,
    bind: directive.branchNameById
  },
  'image-preview': {
    update: directive.preview,
    bind: directive.preview
  }
}